import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Impressoras extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.IMPRESSORAS)
            return null;

        const token = this.props.token;

        const serviceMap = {
            "BADGE": "Crachá",
            "CHECKOUT": "Caixa",
            "DELIVERY": "Expedição",
        };

        const editorFields = [
            { "label": "Origem", "name": "origin" },
            { "label": "Destino", "name": "destination" },
            {
                "label": "Serviço",
                "name": "service",
                "type": "select",
                "options": [
                    {name: serviceMap['BADGE'], id: 'BADGE'},
                    {name: serviceMap["CHECKOUT"], id: 'CHECKOUT'},
                    {name: serviceMap["DELIVERY"], id: 'DELIVERY'},
                ],
                "optionsPair": {
                    label: 'name',
                    value: 'id'
                }
            },
        ];

        const serviceRender = function(data, type) {
            if (type === "display") {
                if (serviceMap[data]) {
                    return serviceMap[data];
                } else {
                    return '';
                }
            } else {
                return data && data.length > 0 ? serviceMap[data] : "";
            }
        };

        const datatablesColumns = [
            { data: "origin", title: "Origem", render: $.datatable.renders.text() },
            { data: "service", title: "Serviço", render: serviceRender },
            { data: "destination", title: "Destino", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/prints/mapping/select',
            createUrl: '/api/prints/mapping/insert',
            editUrl: '/api/prints/mapping/update/_id_',
            removeUrl: '/api/prints/mapping/delete/_id_',
        });

        const pageLength = 20;
        const order = [[0, "asc"]];

        const editorCreateTitle = 'Inserir mapeamento de impressora';
        const editorEditTitle = 'Editar mapeamento de impressora';
        const editorRemoveTitle = 'Remover mapeamento de impressora';
        const editorRemoveMessage = 'Deseja remover este mapeamento de impressora?';

        const domClassName = 'print-mapping-datatables';
        const title = 'Mapeamento de Impressoras';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       pageLength={pageLength}
                       order={order}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Impressoras;


// WEBPACK FOOTER //
// src/views/pages/Impressoras.jsx